
import { useState, useEffect } from 'react';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div
            className={`w-8 h-8 flex items-center justify-center rounded-full ${
              scrolled ? 'bg-rose-500' : 'bg-white/90'
            }`}
          >
            <i
              className={`ri-heart-pulse-fill text-lg ${
                scrolled ? 'text-white' : 'text-rose-500'
              }`}
            ></i>
          </div>
          <span
            className={`font-bold text-lg tracking-tight ${
              scrolled ? 'text-gray-800' : 'text-white'
            }`}
            style={{ fontFamily: 'Pacifico, cursive' }}
          >
            LoveNavi
          </span>
        </div>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`w-10 h-10 flex items-center justify-center cursor-pointer rounded-full ${
            scrolled ? 'text-gray-700' : 'text-white bg-white/20'
          }`}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <i
            className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`}
          ></i>
        </button>
      </div>

      {menuOpen && (
        <div className="bg-white/95 backdrop-blur-md border-t border-gray-100 px-4 py-3 shadow-lg">
          <nav className="flex flex-col gap-1">
            <a
              href="#top"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 py-2.5 px-3 rounded-lg hover:bg-rose-50 transition-colors cursor-pointer text-sm font-medium"
            >
              トップ
            </a>
            <a
              href="#apps"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 py-2.5 px-3 rounded-lg hover:bg-rose-50 transition-colors cursor-pointer text-sm font-medium"
            >
              おすすめアプリ
            </a>
            <a
              href="#girls"
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 py-2.5 px-3 rounded-lg hover:bg-rose-50 transition-colors cursor-pointer text-sm font-medium"
            >
              女の子一覧
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
